<template>
  <article class="about-manufacturing-page">
    <header class="text-block">
      <h1>{{ category.title }}</h1>
      <p>{{ category.description }}</p>
    </header>
    <div class="manufacturing-gallery">
      <tagged-image-aside-slide
        v-for="(image, i) in manufacturingImages"
        v-bind:key="image.id"
        v-bind:image="image"
        v-bind:preferred-image-position="getPreferredImagePosition(i)"
      >
      </tagged-image-aside-slide>
    </div>
    <div class="manufacturing-videos">
      <video-centered
        v-for="videoId in manufacturingYouTubeVideosIds"
        v-bind:key="videoId"
        v-bind:video-id="videoId"
      ></video-centered>
    </div>
  </article>
</template>

<script>
import TaggedImageAsideSlide from '../components/the-content/utils/TaggedImageAsideSlide'
import VideoCentered from '../components/the-content/utils/VideoCentered'
import utils from './utils'

export default {
  name: 'AboutManufacturingPage',
  components: {TaggedImageAsideSlide, VideoCentered},
  data: function () {
    return {
      category: {},
      manufacturingImages: [],
      manufacturingYouTubeVideosIds: ['B7aEU4Nb3-4', 'pFM31kkusLM', 'nsYhLTQSyvg'],
      title: 'Как создаются украшения'
    }
  },
  metaInfo () {
    return {
      title: this.title,
      meta: utils.getDefaultMetaTags({
        description: this.category.meta_description,
        path: this.$router.resolve(this.$route).href,
        title: this.title,
        imageUrl: this.imageForMeta.image,
        imageWidth: this.imageForMeta.width,
        imageHeight: this.imageForMeta.height
      })
    }
  },
  mounted () {
    this.getCategory()
    this.getManufacturingImages()
  },
  updated () {
    if (Object.keys(this.category).length > 0 &&
        this.manufacturingImages.length > 0 &&
        window['__PRERENDER_INJECTED']) {
      document.dispatchEvent(new Event('render-event'))
    }
  },
  computed: {
    imageForMeta: function () {
      return (this.manufacturingImages.length > 0)
        ? this.manufacturingImages[0] : {}
    }
  },
  methods: {
    getCategory: function () {
      this.$http
        .get(`${process.env.API_HOST}/api/v1/site-structure/get-category/manufacturing`)
        .then(response => { this.category = response.body })
    },
    getManufacturingImages: function () {
      const uri = `${process.env.API_HOST}/api/v1/images/get-images-by-tags`
      const repairTags = ['about-page', 'manufacturing-process']
      let uriParams = {include_tags: repairTags.join(',')}

      this.$http
        .get(uri, {params: uriParams})
        .then(response => { this.manufacturingImages = response.body })
    },
    getPreferredImagePosition: function (slideIndex) {
      return (slideIndex % 2 === 1) ? 'right' : 'left'
    }
  }
}
</script>

<style scoped lang="scss">
  .about-manufacturing-page {
    background-color: $default-background-color;
    @include page-block-vertical-padding();
    & > * {
      margin-bottom: 2em !important;
      &:last-child { margin-bottom: 0 !important; }
    }
    & > .text-block {
      @include text-block();
    }
    & > .manufacturing-videos {
      @include vertical-breakpoint-padding("tablet", 2em, 0);
      width: 100%;
      & > * {
        margin-bottom: 1em;
        &:last-child { margin-bottom: 0; }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/AboutManufacturingPage.vue